import React, { useEffect, useState, useContext } from "react"; // eslint-disable-line no-unused-vars
import { makeStyles } from "@material-ui/core/styles";
import { useAuth0 } from "@auth0/auth0-react";
import {
  Button,
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Backdrop,
  CircularProgress,
  Hidden,
  Link,
} from "@material-ui/core";
import ScopedCssBaseline from "@material-ui/core/ScopedCssBaseline";
import {
  ThemeProvider,
  createMuiTheme,
  StylesProvider,
  createGenerateClassName,
} from "@material-ui/core/styles";
import shortid from "shortid";
import * as consts from "../consts";
import { State } from "../store/state";
import {
  addAlert,
  dismissAlert,
  updateCart,
  getProfile,
  setBusy,
} from "../store/actions";
import { shippingAddressIssues, cardIssues } from "../store/validators";
import CardPreview from "./controls/cardPreview";
import CardImage from "./controls/cardImage";
import CardValue from "./controls/cardValue";
import CardQuantity from "./controls/cardQuantity";
import CardType from "./controls/cardType";
import CardMessage from "./controls/cardMessage";
import CSVUpload from "./controls/csvUpload";
import Alert from "./presentational/alert";

const App = (props) => {
  const generateClassName = createGenerateClassName({
    seed: "tbbuilder",
  });

  const theme = createMuiTheme(props.theme);
  const useStyles = makeStyles((theme) => ({
    main: { paddingTop: theme.spacing(2) },
    commands: {
      textAlign: "right",
      marginTop: theme.spacing(2),
      [theme.breakpoints.down("sm")]: {
        paddingRight: theme.spacing(2),
      },
    },
    button: {
      width: "100%",
      marginTop: theme.spacing(2),
      [theme.breakpoints.up("sm")]: {
        width: "unset",
        margin: theme.spacing(2),
      },
    },
    backdrop: {
      zIndex: theme.zIndex.drawer + 1,
      color: "#ffffff",
    },

    cardpreviewcardImage: {
      backgroundRepeat: "no-repeat",
      backgroundColor: "transparent",
      borderRadius: "14px",
      border: "1px solid #d8d8d8",
      backgroundSize: "cover",
      overflow: "hidden",
    },
    cardpreviewoverlay: {
      width: "100%",
      display: "block",
    },

    cardimagemain: {
      // margin: "0px",
    },
    cardimagetoggle: {
      height: "56px",
      fontSize: "1rem",
      textTransform: "none",
      "&:active": {
        backgroundColor: "unset",
        color: theme.palette.secondary.main,
      },
      "&:focus": {
        backgroundColor: "unset",
        color: theme.palette.secondary.main,
      },
      "&:hover": { color: theme.palette.secondary.main },
    },
    uploadcustomimagetitle: {
      fontWeight: "bold",
      color: "rgba(0,0,0,.87)",
      margin: "0px !important",
    },
    uploadcustomimageinstruction: {
      marginBottom: "6px",
    },
    cardimagetitle: {
      textAlign: "left",
      display: "inline-block",
      paddingRight: theme.spacing(2),
    },
    cardimagetext: {
      textAlign: "left",
    },
    cardimagecategories: {
      textAlign: "left",
    },
    cardimagestockimages: {
      margin: "0px",
    },

    cardimagethumbnail: {
      marginBottom: theme.spacing(1),
    },
    cardimagecardPreview: {
      backgroundColor: "#ffffff",
      margin: "14px 4px",
      cursor: "pointer",
    },
    cardimagelink: {
      cursor: "pointer",
    },
    cardimagecardImage: {
      cursor: "pointer",
      backgroundRepeat: "no-repeat",
      backgroundColor: "#ffffff",
      [theme.breakpoints.up("md")]: {
        borderRadius: "14px",
      },
      [theme.breakpoints.down("sm")]: {
        borderRadius: "4px",
      },
      border: "1px solid #d8d8d8",
      backgroundSize: "cover",
      overflow: "hidden",
    },
    cardimageselectedCardImage: {
      backgroundRepeat: "no-repeat",
      [theme.breakpoints.up("md")]: {
        borderRadius: "14px",
      },
      [theme.breakpoints.down("sm")]: {
        borderRadius: "4px",
      },
      backgroundSize: "cover",
      overflow: "hidden",
      boxShadow: " 0 0 7px 0 #d67a4b",
      border: "solid 2px #d67a4b",
      backgroundColor: "#ffffff",
    },
    cardimageuploadPaper: {
      "&:hover": {
        boxShadow:
          "0px 2px 1px -1px rgb(0 0 0), 0px 1px 1px 0px rgb(0 0 0), 0px 1px 3px 0px rgb(0 0 0)",
      },
    },
    cardimagedropZone: {
      padding: theme.spacing(2),
      cursor: "pointer",
      marginBottom: theme.spacing(2),
    },
    cardimageoverlay: {
      width: "100%",
      display: "block",
    },
    cardimagecommands: {
      textAlign: "right",
    },
    cardimagebutton: {
      color: "#ffffff",
    },
    cardimagecrop: {
      "& .ReactCrop": {
        position: "relative",
        display: "inline-block",
        cursor: "crosshair",
        overflow: "hidden",
        maxWidth: "100%",
        "&:focus": {
          outline: "none",
        },
      },
      "& img": {
        width: "100%",
        maxHeight: "300px",
      },
      "& .ReactCrop--disabled": {
        cursor: "inherit",
      },
      "& .ReactCrop--locked": {
        cursor: "inherit",
      },
      "& .ReactCrop__crop-selection": {
        position: "absolute",
        top: "0px",
        left: "0px",
        transform: "translate3d(0, 0, 0)",
        boxSizing: "border-box",
        cursor: "move",
        boxShadow: "0 0 0 9999em rgba(0, 0, 0, 0.5)",
        touchAction: "manipulation",
        border: "1px solid",
        borderImageSource:
          "url('data:image/gif;base64,R0lGODlhCgAKAJECAAAAAP///////wAAACH/C05FVFNDQVBFMi4wAwEAAAAh/wtYTVAgRGF0YVhNUDw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6OEI5RDc5MTFDNkE2MTFFM0JCMDZEODI2QTI4MzJBOTIiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6OEI5RDc5MTBDNkE2MTFFM0JCMDZEODI2QTI4MzJBOTIiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoTWFjaW50b3NoKSI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuZGlkOjAyODAxMTc0MDcyMDY4MTE4MDgzQzNDMjA5MzREQ0ZDIiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOjAyODAxMTc0MDcyMDY4MTE4MDgzQzNDMjA5MzREQ0ZDIi8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+Af/+/fz7+vn49/b19PPy8fDv7u3s6+rp6Ofm5eTj4uHg397d3Nva2djX1tXU09LR0M/OzczLysnIx8bFxMPCwcC/vr28u7q5uLe2tbSzsrGwr66trKuqqainpqWko6KhoJ+enZybmpmYl5aVlJOSkZCPjo2Mi4qJiIeGhYSDgoGAf359fHt6eXh3dnV0c3JxcG9ubWxramloZ2ZlZGNiYWBfXl1cW1pZWFdWVVRTUlFQT05NTEtKSUhHRkVEQ0JBQD8+PTw7Ojk4NzY1NDMyMTAvLi0sKyopKCcmJSQjIiEgHx4dHBsaGRgXFhUUExIREA8ODQwLCgkIBwYFBAMCAQAAIfkEBQoAAgAsAAAAAAoACgAAAhWEERkn7W3ei7KlagMWF/dKgYeyGAUAIfkEBQoAAgAsAAAAAAoACgAAAg+UYwLJ7RnQm7QmsCyVKhUAIfkEBQoAAgAsAAAAAAoACgAAAhCUYgLJHdiinNSAVfOEKoUCACH5BAUKAAIALAAAAAAKAAoAAAIRVISAdusPo3RAzYtjaMIaUQAAIfkEBQoAAgAsAAAAAAoACgAAAg+MDiem7Q8bSLFaG5il6xQAIfkEBQoAAgAsAAAAAAoACgAAAg+UYRLJ7QnQm7SmsCyVKhUAIfkEBQoAAgAsAAAAAAoACgAAAhCUYBLJDdiinNSEVfOEKoECACH5BAUKAAIALAAAAAAKAAoAAAIRFISBdusPo3RBzYsjaMIaUQAAOw==')",
        borderImageSlice: "1",
        borderImageRepeat: "repeat",
      },
      "& .ReactCrop--disabled .ReactCrop__crop-selection": {
        cursor: "inherit",
      },
      "& .ReactCrop--circular-crop .ReactCrop__crop-selection": {
        borderRadius: "50%",
        boxShadow: "0px 0px 1px 1px white, 0 0 0 9999em rgba(0, 0, 0, 0.5)",
      },
      "& .ReactCrop--invisible-crop .ReactCrop__crop-selection": {
        display: "none",
      },
      "& .ReactCrop__rule-of-thirds-vt::before": {
        content: "''",
        display: "block",
        position: "absolute",
        backgroundColor: "rgba(255, 255, 255, 0.4)",
        width: "1px",
        height: "100%",
        left: "33.3333%",
      },
      "& .ReactCrop__rule-of-thirds-vt::after": {
        content: "''",
        display: "block",
        position: "absolute",
        backgroundColor: "rgba(255, 255, 255, 0.4)",
        width: "1px",
        height: "100%",
        left: "66.6666%",
      },
      "& .ReactCrop__rule-of-thirds-hz::before": {
        content: "''",
        display: "block",
        position: "absolute",
        backgroundColor: "rgba(255, 255, 255, 0.4)",
        width: "100%",
        height: "1px",
        top: "33.3333%",
      },
      "& .ReactCrop__rule-of-thirds-hz::after": {
        content: "''",
        display: "block",
        position: "absolute",
        backgroundColor: "rgba(255, 255, 255, 0.4)",
        width: "100%",
        height: "1px",
        top: "66.6666%",
      },
      "& .ReactCrop__drag-handle": {
        position: "absolute",
      },
      "& .ReactCrop__drag-handle::after": {
        position: "absolute",
        content: "''",
        display: "block",
        width: "10px",
        height: "10px",
        backgroundColor: "rgba(0, 0, 0, 0.2)",
        border: "1px solid rgba(255, 255, 255, 0.7)",
        boxSizing: "border-box",
        outline: "1px solid transparent",
      },
      "& .ord-nw": {
        top: "0px",
        left: "0px",
        marginTop: "-5px",
        marginLeft: "-5px",
        cursor: "nw-resize",
      },
      "& .ord-nw::after": {
        top: "0px",
        left: "0px",
      },
      "& .ord-n": {
        top: "0px",
        left: "50%",
        marginTop: "-5px",
        marginLeft: "-5px",
        cursor: "n-resize",
      },
      "& .ord-n::after": {
        top: "0px",
      },
      "& .ord-ne": {
        top: "0px",
        right: "0px",
        marginTop: "-5px",
        marginRight: "-5px",
        cursor: "ne-resize",
      },
      "& .ord-ne::after": {
        top: "0px",
        right: "0px",
      },
      "& .ord-e": {
        top: "50%",
        right: "0px",
        marginTop: "-5px",
        marginRight: "-5px",
        cursor: "e-resize",
      },
      "& .ord-e::after": {
        right: "0px",
      },
      "& .ord-se": {
        bottom: "0px",
        right: "0px",
        marginBottom: "-5px",
        marginRight: "-5px",
        cursor: "se-resize",
      },
      "& .ord-se::after": {
        bottom: "0px",
        right: "0px",
      },
      "& .ord-s": {
        bottom: "0px",
        left: "50%",
        marginBottom: "-5px",
        marginLeft: "-5px",
        cursor: "s-resize",
      },
      "& .ord-s::after": {
        bottom: "0px",
      },
      "& .ord-sw": {
        bottom: "0px",
        left: "0px",
        marginBottom: "-5px",
        marginLeft: "-5px",
        cursor: "sw-resize",
      },
      "& .ord-sw::after": {
        bottom: "0px",
        left: "0px",
      },
      "& .ord-w": {
        top: "50%",
        left: "0px",
        marginTop: "-5px",
        marginLeft: "-5px",
        cursor: "w-resize",
      },
      "& .ord-w::after": {
        left: "0px",
      },
      "& .ReactCrop__disabled .ReactCrop__drag-handle": {
        cursor: "inherit",
      },
      "& .ReactCrop__drag-bar": {
        position: "absolute",
      },
      "& .ReactCrop__drag-bar.ord-n": {
        top: "0px",
        left: "0px",
        width: "100%",
        height: "6px",
        marginTop: "-3px",
      },
      "& .ReactCrop__drag-bar.ord-e": {
        top: "0px",
        right: "0px",
        width: "6px",
        height: "100%",
        marginRight: "-3px",
      },
      "& .ReactCrop__drag-bar.ord-s": {
        bottom: "0px",
        left: "0px",
        width: "100%",
        height: "6px",
        marginBottom: "-3px",
      },
      "& .ReactCrop__drag-bar.ord-w": {
        top: "0px",
        left: "0px",
        width: "6px",
        height: "100%",
        marginLeft: "-3px",
      },
      "& .ReactCrop--new-crop .ReactCrop__drag-bar": {
        display: "none",
      },
      "& .ReactCrop--new-crop .ReactCrop__drag-handle": {
        display: "none",
      },
      "& .ReactCrop--fixed-aspect .ReactCrop__drag-bar": {
        display: "none",
      },
      "& .ReactCrop--fixed-aspect .ReactCrop__drag-handle.ord-n": {
        display: "none",
      },
      "& .ReactCrop--fixed-aspect .ReactCrop__drag-handle.ord-e": {
        display: "none",
      },
      "& .ReactCrop--fixed-aspect .ReactCrop__drag-handle.ord-s": {
        display: "none",
      },
      "& .ReactCrop--fixed-aspect .ReactCrop__drag-handle.ord-w": {
        display: "none",
      },
    },
    cardimagerequirements: {
      textAlign: "left",
    },

    cardquantitymain: {
      marginTop: theme.spacing(2),
    },
    cardquantitytitle: {
      textAlign: "left",
      display: "inline-block",
      paddingRight: theme.spacing(2),
    },
    cardquantityinputs: {
      width: "190px",
      lineHeight: "56px",
      textAlign: "left",
    },
    cardquantityinput: {
      width: "100px",
      "& p": {
        whiteSpace: "nowrap",
        marginLeft: "0px",
      },
      "& input": {
        height: "100%",
        padding: "18.5px 14px",
        border: "0",
        background: "none",
      },
    },
    cardquantitybutton: {
      padding: "0px",
      margin: "0 5px",
      "&:hover svg": { color: theme.palette.secondary.main },
    },
    cardquantityrepeatable: {
      display: "inline-block",
    },

    bulkoptiontext: {},
    bulkoptiontextinfo: {
      marginTop: "-10px !important",
      marginBottom: "16px !important",
      marginLeft: ".5em",
    },
    bulkEntryLink: {
      cursor: "pointer",
    },
    bulkentrytoggle: {
      height: "56px",
      fontSize: "1rem",
      textTransform: "none",
      "&:active": {
        backgroundColor: "unset",
        color: theme.palette.secondary.main,
      },
      "&:focus": {
        backgroundColor: "unset",
        color: theme.palette.secondary.main,
      },
      "&:hover": { color: theme.palette.secondary.main },
    },
    fileInput: {
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
    },
    bulkoptioniconButton: {
      "&:focus": { color: "inherit" },
      "&:hover": { color: "inherit" },
    },

    cardtypemain: {
      marginTop: theme.spacing(4),
    },
    cardtypetitle: {
      textAlign: "left",
      display: "inline-block",
      paddingRight: theme.spacing(2),
    },
    cardtypeoptions: {},
    cardtypeoption: {
      textAlign: "center",
      [theme.breakpoints.down("md")]: {
        margin: theme.spacing(1),
        padding: theme.spacing(2),
      },
      [theme.breakpoints.up("md")]: {
        margin: theme.spacing(2),
        padding: theme.spacing(2),
      },
      "& img": {
        display: "inline-block",
        [theme.breakpoints.down("sm")]: {
          maxWidth: "90px",
        },
        [theme.breakpoints.up("md")]: {
          maxWidth: "125px",
        },
      },
      color: theme.palette.text.secondary,
      cursor: "pointer",
    },
    cardtypeoptiondetails: {
      marginLeft: theme.spacing(2),
    },
    cardtypeiconNudge: {
      marginRight: "4px",
    },
    cardtypeselectedOption: {
      textAlign: "center",
      [theme.breakpoints.down("md")]: {
        margin: theme.spacing(1),
        padding: theme.spacing(2),
      },
      [theme.breakpoints.up("md")]: {
        margin: theme.spacing(2),
        padding: theme.spacing(2),
      },
      "& img": {
        display: "inline-block",
        [theme.breakpoints.down("sm")]: {
          maxWidth: "90px",
        },
        [theme.breakpoints.up("md")]: {
          maxWidth: "125px",
        },
      },
      color: theme.palette.text.secondary,
      cursor: "pointer",
      boxShadow: " 0 0 7px 0 #d67a4b",
      border: "solid 2px #d67a4b",
      backgroundColor: "#ffffff",
    },
    cardtypedetails: {
      [theme.breakpoints.down("md")]: {
        margin: theme.spacing(1),
      },
      [theme.breakpoints.up("md")]: {
        margin: theme.spacing(2),
      },
    },
    cardtypetoggle: {
      height: "56px",
      fontSize: "1rem",
      textTransform: "none",
      "&:active": {
        backgroundColor: "unset",
        color: theme.palette.secondary.main,
      },
      "&:focus": {
        backgroundColor: "unset",
        color: theme.palette.secondary.main,
      },
      "&:hover": { color: theme.palette.secondary.main },
    },
    cardtypetogglefull: {
      height: "56px",
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
      fontSize: "1rem",
      textTransform: "none",
      "&:active": {
        backgroundColor: "unset",
        color: theme.palette.secondary.main,
      },
      "&:focus": {
        backgroundColor: "unset",
        color: theme.palette.secondary.main,
      },
      "&:hover": { color: theme.palette.secondary.main },
    },
    cardtypelink: {
      cursor: "pointer",
    },
    cardtypeform: {
      width: "100%",
      "& input": {
        height: "100%",
        padding: "18.5px 14px",
        border: "0",
        background: "none",
      },
    },
    cardtypeprintOptions: {
      paddingTop: theme.spacing(1),
      "& ul": { paddingLeft: "20px" },
      textAlign: "left",
    },
    cardtypeplasticOptions: {
      paddingTop: theme.spacing(1),
      textAlign: "left",
    },
    cardtypeemailOptions: {
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1),
      textAlign: "left",
    },
    cardtypeemailInputs: {
      "& label": { fontSize: "24px" },
      width: "200px",
      [theme.breakpoints.down("xs")]: {
        width: "100%",
      },
    },
    cardtypeexampleContainter: {
      [theme.breakpoints.down("sm")]: {
        height: "100%",
      },
    },
    cardtypeexample: {
      width: "100%",
      maxHeight: "100%",
    },
    cardtypeexampleButton: {
      textAlign: "right",
    },
    cardtypedateInput: {
      maxWidth: "150px",
      "& input": {
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(2),
      },
    },

    cardvaluemain: {
      marginTop: theme.spacing(2),
    },
    cardvaluetitle: {
      textAlign: "left",
    },
    cardvalueinput: {
      width: "114px",
      "& p": {
        whiteSpace: "nowrap",
        marginLeft: "0px",
      },
      "& input": {
        height: "100%",
        padding: "18.5px 4px",
        border: "0",
        background: "none",
      },
    },
    cardvaluebutton: {
      padding: "0px",
      margin: "0 5px",
      "&:hover svg": { color: theme.palette.secondary.main },
    },
    cardvaluerepeatable: {
      display: "inline-block",
    },
    cardvalueautoOption: {
      width: "100px",
      height: "80px",
      "&:active": { backgroundColor: "unset" },
      "&:focus": { backgroundColor: "unset" },
    },

    cardmessagemain: {
      marginTop: theme.spacing(2),
    },
    cardmessageglobal: {
      marginTop: theme.spacing(2),
    },
    cardmessagedelivery: {
      marginTop: theme.spacing(2),
    },
    cardmessagesynchronizeOption: {
      marginTop: theme.spacing(2),
      marginLeft: theme.spacing(2),
    },
    cardmessagerows: {
      marginTop: theme.spacing(2),
    },
    cardmessageinput: {
      "& input": {
        height: "100%",
        padding: "18.5px 14px",
        border: "0",
        background: "none",
      },
    },
    cardmessagelimit: {
      textAlign: "right",
      display: "block",
    },
    cardmessagenativeSelectInput: {
      "& select": {
        height: "60px",
      },
    },
    cardmessageremove: {
      textAlign: "right",
    },
    cardmessagedivider: {
      marginTop: theme.spacing(3),
    },
    cardmessagecardNumber: {
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(1),
    },
    cardmessagesendto: {
      paddingTop: theme.spacing(2),
    },

    alerterror: {
      "& .tbbuilder-MuiSnackbarContent-root": {
        backgroundColor: "#f44336",
      },
    },
    alertsuccess: {
      "& .tbbuilder-MuiSnackbarContent-root": {
        backgroundColor: "#52b202",
      },
    },
  }));
  const classes = useStyles();
  const { state, dispatch } = useContext(State);
  const {
    isLoading,
    isAuthenticated,
    loginWithRedirect,
    user,
    getAccessTokenSilently,
  } = useAuth0();
  const [confirmUseAddress, setConfirmUseAddress] = useState(false);
  const [validate, setValidate] = useState(false);
  const [cartItemID, setCartItemID] = useState(null);
  const [selectedCardImage, setSelectedCardImage] = useState(
    `${consts.BLOB_URL}stockimages4/TisBestLogo.png`
  );
  const [selectedImageGroupingId, setSelectedImageGroupingId] = useState("");
  const [cardValue, setCardValue] = useState(consts.DEFAULT_CARD_VALUE);
  const [cardType, setCardType] = useState(consts.CARD_TYPE_EMAIL);
  const [mailOption, setMailOption] = useState(consts.DEFAULT_MAIL_OPTION);
  const [emailOption, setEmailOption] = useState(consts.DEFAULT_EMAIL_OPTION);
  const [bulkEntry, setBulkEntry] = useState(false);
  const [synchronize, setSynchronize] = useState(
    consts.DEFAULT_SYNCHRONIZE_VALUE
  );
  const [cardDetails, setCardDetails] = useState([
    {
      to: "",
      from: "",
      email: "",
      deliveryDate: new Date(),
      message: "",
      shipping: {
        name: "",
        company: "",
        address: "",
        city: "",
        state: consts.DEFAULT_SHIPPING_STATE,
        zip: "",
        method: consts.DEFAULT_SHIPPING_METHOD,
      },
    },
  ]);

  const submitCart = (overrideAddress) => {
    setValidate(true);
    setBusy(true, dispatch).then(() => {
      let cardBuilderSettings = {
        bulkEntry: false,
        cartItemID: shortid.generate(),
        cardImage: selectedCardImage,
        cardValue: cardValue,
        cardType: cardType,
        mailOption: mailOption,
        emailOption: emailOption,
        cardDetails: cardDetails,
      };
      let validateCards = cardIssues(cardBuilderSettings);
      if (validateCards.length == 0) {
        let addressIssues = shippingAddressIssues(
          cardBuilderSettings,
          state.cart
        );
        if (overrideAddress || !addressIssues) {
          let cart = [...state.cart];
          if (cartItemID) {
            cart = cart.map((item) => {
              if (cartItemID !== item.cartItemID) {
                return item;
              } else {
                return {
                  ...item,
                  cardImage: selectedCardImage,
                  cardValue: cardValue,
                  cardType: cardType,
                  mailOption: mailOption,
                  emailOption: emailOption,
                  cardDetails: cardDetails,
                  synchronize: synchronize,
                  selectedImageGroupingId: selectedImageGroupingId,
                };
              }
            });
          } else {
            cart.push({
              bulkEntry: false,
              cartItemID: shortid.generate(),
              cardImage: selectedCardImage,
              cardValue: cardValue,
              cardType: cardType,
              mailOption: mailOption,
              emailOption: emailOption,
              cardDetails: cardDetails,
              synchronize: synchronize,
              selectedImageGroupingId: selectedImageGroupingId,
            });
          }

          let existingSTM = state.cart.find((item) => {
            return (
              item.cardType == consts.CARD_TYPE_PLASTIC &&
              item.mailOption == consts.PLASTIC_TYPE_ME
            );
          });
          let shippingMethod =
            existingSTM && existingSTM.cardDetails
              ? existingSTM.cardDetails[0].shipping.method
              : consts.DEFAULT_SHIPPING_METHOD;
          cardDetails.map((cardDetail) => {
            cardDetail.shipping.method = shippingMethod;
          });
          cart.map((item) => {
            if (
              overrideAddress &&
              item.cardType == consts.CARD_TYPE_PLASTIC &&
              item.mailOption == consts.PLASTIC_TYPE_ME
            ) {
              item.cardDetails.map((cardDetail) => {
                cardDetail.shipping.name = cardDetails[0].shipping.name;
                cardDetail.shipping.company = cardDetails[0].shipping.company;
                cardDetail.shipping.address = cardDetails[0].shipping.address;
                cardDetail.shipping.city = cardDetails[0].shipping.city;
                cardDetail.shipping.state = cardDetails[0].shipping.state;
                cardDetail.shipping.zip = cardDetails[0].shipping.zip;
                cardDetail.shipping.method = cardDetails[0].shipping.method;
              });
            }
          });
          updateCart(cart, dispatch).then(() => {
            if (typeof window !== "undefined") {
              if (window.fbq != null) {
                window.fbq("track", "AddToCart");
              }
            }
            window.location.href = "/checkout";
          });
        } else {
          setBusy(false, dispatch).then(() => {
            setConfirmUseAddress(true);
          });
        }
      } else {
        setBusy(false, dispatch);
        addAlert(
          {
            message: validateCards[0],
            type: consts.ALERT_TYPE_ERROR,
          },
          dispatch
        );
      }
    });
  };

  const getQueryParams = (params, url) => {
    let href = url;
    let reg = new RegExp("[?&]" + params + "=([^&#]*)", "i");
    let queryString = reg.exec(href);
    return queryString ? decodeURI(queryString[1]) : null;
  };

  useEffect(() => {
    let cartItemID = getQueryParams("cartItemID", location.href);
    if (cartItemID) {
      let cartItem = state.cart.find((item) => {
        return cartItemID === item.cartItemID;
      });
      if (cartItem) {
        setCartItemID(cartItem.cartItemID);
        setSelectedCardImage(cartItem.cardImage);
        setCardValue(cartItem.cardValue);
        setCardType(cartItem.cardType);
        setMailOption(cartItem.mailOption);
        setEmailOption(cartItem.emailOption);
        setCardDetails(cartItem.cardDetails);
        setSynchronize(cartItem.synchronize);
        setSelectedImageGroupingId(cartItem.selectedImageGroupingId);
      }
    }
  }, []);

  useEffect(() => {
    if (
      state.profile &&
      cardType == consts.CARD_TYPE_PLASTIC &&
      mailOption == consts.PLASTIC_TYPE_ME &&
      cardDetails[0].shipping.name == "" &&
      cardDetails[0].shipping.company == "" &&
      cardDetails[0].shipping.address == "" &&
      cardDetails[0].shipping.city == "" &&
      cardDetails[0].shipping.state == consts.DEFAULT_SHIPPING_STATE &&
      cardDetails[0].shipping.zip == ""
    ) {
      let updatedCardDetails = [...cardDetails];
      let shipping =
        state.profile.addressBook && state.profile.addressBook.shipping
          ? state.profile.addressBook.shipping
          : {
              name: "",
              company: "",
              address: "",
              city: "",
              state: "",
              zip: "",
            };

      updatedCardDetails.map((cardDetail) => {
        cardDetail.shipping.name = shipping.name;
        cardDetail.shipping.company = shipping.company;
        cardDetail.shipping.address = shipping.address;
        cardDetail.shipping.city = shipping.city;
        cardDetail.shipping.state = shipping.state;
        cardDetail.shipping.zip = shipping.zip;
      });
      setCardDetails(updatedCardDetails);
    }
  }, [cardType, mailOption]);

  useEffect(() => {
    if (!isLoading && isAuthenticated && user) {
      getProfile(getAccessTokenSilently, dispatch);
    }
  }, [isAuthenticated, isLoading, user]);

  const updateCardCount = (cardQuantity) => {
    let updatedCardDetails = [...cardDetails];
    if (cardDetails.length > cardQuantity) {
      while (updatedCardDetails.length > cardQuantity) {
        updatedCardDetails.pop();
      }
    } else {
      while (updatedCardDetails.length < cardQuantity) {
        updatedCardDetails.push({
          to: "",
          from: synchronize ? cardDetails[0].from : "",
          email: "",
          deliveryDate: cardDetails[0].deliveryDate,
          message: synchronize ? cardDetails[0].message : "",
          shipping: {
            name:
              cardType == consts.CARD_TYPE_PLASTIC &&
              mailOption == consts.PLASTIC_TYPE_ME
                ? cardDetails[0].shipping.name
                : "",
            company:
              cardType == consts.CARD_TYPE_PLASTIC &&
              mailOption == consts.PLASTIC_TYPE_ME
                ? cardDetails[0].shipping.company
                : "",
            address:
              cardType == consts.CARD_TYPE_PLASTIC &&
              mailOption == consts.PLASTIC_TYPE_ME
                ? cardDetails[0].shipping.address
                : "",
            city:
              cardType == consts.CARD_TYPE_PLASTIC &&
              mailOption == consts.PLASTIC_TYPE_ME
                ? cardDetails[0].shipping.city
                : "",
            state:
              cardType == consts.CARD_TYPE_PLASTIC &&
              mailOption == consts.PLASTIC_TYPE_ME
                ? cardDetails[0].shipping.state
                : consts.DEFAULT_SHIPPING_STATE,
            zip:
              cardType == consts.CARD_TYPE_PLASTIC &&
              mailOption == consts.PLASTIC_TYPE_ME
                ? cardDetails[0].shipping.zip
                : "",
            method:
              cardType == consts.CARD_TYPE_PLASTIC
                ? cardDetails[0].shipping.method
                : consts.DEFAULT_SHIPPING_METHOD,
          },
        });
      }
    }
    if (updatedCardDetails.length == 1) {
      setSynchronize(consts.SYNCHRONIZE_YES);
    }
    setCardDetails(updatedCardDetails);
  };

  const renderConfirmAddress = () => {
    return (
      <Dialog
        open={confirmUseAddress}
        onClose={() => {
          setConfirmUseAddress(false);
        }}
      >
        <DialogTitle>Address Issue</DialogTitle>
        <DialogContent>
          <DialogContentText>
            You have already added a mail to me plastic card to your cart with a
            different shipping address. Would you like to update the shipping
            address on all the "mail to me" cards currently in your cart?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            variant="outlined"
            onClick={() => {
              submitCart(true);
            }}
            color="primary"
          >
            Update Addresses
          </Button>
          <Button
            variant="outlined"
            onClick={() => {
              setConfirmUseAddress(false);
            }}
            color="primary"
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    );
  };

  const renderLoginButton = () => {
    if (process.env.NODE_ENV === "development" && !isAuthenticated) {
      return (
        <Button
          fullWidth={true}
          color="secondary"
          variant="outlined"
          className={classes.button}
          onClick={() => {
            loginWithRedirect({
              appState: { returnTo: window.location.pathname },
            });
          }}
        >
          Sign In
        </Button>
      );
    } else {
      return null;
    }
  };

  return (
    <StylesProvider generateClassName={generateClassName}>
      <ThemeProvider theme={theme}>
        <ScopedCssBaseline className={classes.main}>
          <Backdrop className={classes.backdrop} open={state.busy}>
            <CircularProgress color="inherit" />
          </Backdrop>
          {confirmUseAddress && renderConfirmAddress()}
          {state.alerts.length > 0 && (
            <Alert
              classes={classes}
              alert={state.alerts[0]}
              onDismiss={() => {
                dismissAlert(dispatch);
              }}
            />
          )}
          {bulkEntry && (
            <CSVUpload
              classes={classes}
              cardType={cardType}
              bulkEntry={bulkEntry}
              mailOption={mailOption}
              emailOption={emailOption}
              cardDetails={cardDetails}
              onClose={() => {
                setBulkEntry(false);
              }}
              setCardDetails={(value) => {
                setCardDetails(value);
                setValidate(true);
                setSynchronize(consts.SYNCHRONIZE_NO);
              }}
            />
          )}
          <Grid container spacing={2}>
            <Grid item xs={12} md={3}>
              {renderLoginButton()}
              <CardPreview
                classes={classes}
                selectedCardImage={selectedCardImage}
                cardOverlay={consts.CARD_OVERLAY}
              />
            </Grid>
            <Grid container item xs={12} md={9}>
              <Grid item xs={12}>
                <CardImage
                  classes={classes}
                  selectedCardImage={selectedCardImage}
                  selectedImageGroupingId={selectedImageGroupingId}
                  cardOverlay={consts.CARD_OVERLAY}
                  onSelectCardImage={(cardImage) => {
                    if (cardImage) {
                      setSelectedCardImage(cardImage);
                    } else {
                      setSelectedCardImage(
                        `${consts.BLOB_URL}stockimages4/TisBestLogo.png`
                      );
                    }
                  }}
                  onSelectImageGroupingId={(imageGroupingId) => {
                    setSelectedImageGroupingId(imageGroupingId);
                  }}
                />
              </Grid>
              <Grid item xs={12}>
                <CardValue
                  classes={classes}
                  cardValue={cardValue}
                  onCardValueChanged={(value) => {
                    setCardValue(value);
                  }}
                />
              </Grid>
              <Grid item xs={12}>
                <CardType
                  classes={classes}
                  cardType={cardType}
                  mailOption={mailOption}
                  deliveryDate={cardDetails[0].deliveryDate}
                  onCardTypeChanged={(value) => {
                    setCardType(value);
                  }}
                  onMailOptionChanged={(value) => {
                    setMailOption(value);
                  }}
                  onDeliveryDateChanged={(value) => {
                    let updatedCardDetails = [...cardDetails];
                    updatedCardDetails.map((cardDetail) => {
                      cardDetail.deliveryDate = value;
                    });
                    setCardDetails(updatedCardDetails);
                  }}
                />
              </Grid>
              <Grid item xs={12}>
                <CardQuantity
                  classes={classes}
                  cardDetails={cardDetails}
                  openBulkEntry={() => {
                    setBulkEntry(true);
                  }}
                  onCardQuantityChanged={(value) => {
                    // if (
                    //   value >= consts.MIN_CARD_QUANTITY &&
                    //   value <= consts.MAX_CARD_QUANTITY
                    // ) {
                    if (value >= consts.MIN_CARD_QUANTITY) {
                      if (
                        cardDetails.length <= value ||
                        confirm(
                          `Are you sure you want to remove the last ${
                            cardDetails.length - value
                          } card(s) you added?`
                        )
                      ) {
                        updateCardCount(value);
                      }
                    }
                  }}
                />
              </Grid>
              <Grid item xs={12}>
                <CardMessage
                  classes={classes}
                  cardDetails={cardDetails}
                  cardType={cardType}
                  mailOption={mailOption}
                  validate={validate}
                  synchronize={synchronize}
                  onSynchronizeChanged={(value) => {
                    setSynchronize(value);
                  }}
                  onCardDetailsChanged={(value) => {
                    setCardDetails(value);
                  }}
                  onRemoveCard={(index) => {
                    if (
                      cardDetails.length > 1 &&
                      confirm("Are you sure you want to remove this card?")
                    ) {
                      updateCardCount(cardDetails.length - 1);
                      let updatedCardDetails = [...cardDetails];
                      updatedCardDetails.splice(index, 1);
                      setCardDetails(updatedCardDetails);
                    }
                  }}
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} className={classes.commands}>
            {cartItemID ? (
              <Button
                className={classes.button}
                variant="outlined"
                color="secondary"
                onClick={() => {
                  window.location.href = "/checkout";
                }}
              >
                Cancel
              </Button>
            ) : null}
            <Button
              className={classes.button}
              variant="contained"
              color="secondary"
              disabled={state.busy}
              onClick={() => {
                submitCart(false);
              }}
            >
              {cartItemID
                ? `Confirm Edits`
                : `Add ${cardDetails.length} Gift ${
                    cardDetails.length > 1 ? "Cards" : "Card"
                  } to Cart`}
            </Button>
          </Grid>
        </ScopedCssBaseline>
      </ThemeProvider>
    </StylesProvider>
  );
};
export default App;
